// extracted by css-extract-rspack-plugin
export default {"nodeRoot":"P66jH","selected":"UTVJ2","dropTarget":"qnivX","button":"j_R0z","link":"ZJJc_","draggable":"HBMdM","dragIcon":"Ma4Hn","dragging":"TKJ1t"};